import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/dataflow/message/modify";

export class PostDataFlowModifyMessageCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: PostDataFlowModifyMessageReqData;

    constructor(rayId: string, message: string) {
        super();
        this.payload = new PostDataFlowModifyMessageReqData(rayId, message);
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

export class PostDataFlowModifyMessageReqData {
    rayId: string;
    message: string;

    constructor(rayId: string, message: string) {
        this.rayId = rayId;
        this.message = message;
    }
}
